<template>
	<div>
		<b-card no-body>
			<b-card-img
				v-if="assetLink.source"
				v-img
				:src="assetLink.source"
				:alt="assetLink.fileName"
			></b-card-img>
			
            <b-card-text>
            <b-link v-if="direction == 'up'"
				class="float-right mb-2  mt-2  mr-2"
				title="Upload a new file"
				@click.prevent="chooseFile"
			>
				<b-icon font-scale="1.5" icon="plus-square"></b-icon>
			</b-link>
            </b-card-text>
		</b-card>

		<!-- uploads -->

		<input 
			v-show="false"
			:accept="accept"
			type="file"
			class="invisible"
			ref="files"
			multiple
			@change.prevent="uploadFile"
		/>

		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import FileService from "@/api-services/file.service";
import Confirm from "@/components/partials/confirm";
import { dateFuncs } from "@/globs.js";
import Vue from "vue";
import VueImg from "v-img";

Vue.use(VueImg);

const assetType = {
	1: { heading: "Images", accept: "image/*" },
};

export default {
	name: "ImageAsset",

	components: { Confirm },

	// things we have inherited from our parent
	props: ["asset", "type", "relate", "folder", "direction"],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			assetLink: {},
			files: [],
			fullscreen: false,
		};
	},

	computed: {
		heading: function () {
			return "Images";
		},

		accept: function () {
			return "image/*";
		},
	},

	created() {
		// if we get here and already have an array, then don't wait for a watch that may never come.
		if (this.asset) {
			var unwatch = this.$watch("asset");
			unwatch();
			this.fetchExistingAsset();
		}
	},

	// things we do to data
	methods: {
		chooseFile() {
			this.$refs.files.click();
		},

		// GET AND ENCODE ASSET
		fetchExistingAsset() {
			if (this.asset) {
				this.streamToBase64(this.asset);
			}
		},

		streamToBase64(_asset) {
			FileService.getStream(_asset.NanId)
				.then((res) => {
					let assetLink = {
						guid: _asset.NanId,
						fileName: _asset.FileName,
						contentType: _asset.ContentType,
						added: dateFuncs.backEndDateFormat(_asset.Added),
						source: this.imageEncode(res.data),
					};
					this.assetLink = assetLink;
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		// put the stream into a base64 encoded string ready for the src of the img element.
		imageEncode(arrayBuffer) {
			let b64encoded = btoa(
				[].reduce.call(
					new Uint8Array(arrayBuffer),
					function (p, c) {
						return p + String.fromCharCode(c);
					},
					""
				)
			);
			let mimetype = "image/jpeg";
			return "data:" + mimetype + ";base64," + b64encoded;
		},

		downloadFile(_asset) {
			FileService.get(_asset.guid)
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", _asset.fileName);
					document.body.appendChild(link);
					link.click();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		/*
           UPLOAD NEW FILES
        */
		submitFile() {
			//Initialize the form data
			let formData = new FormData();

			// Iterate over any file sent over appending the files to the form data.
			for (var i = 0; i < this.files.length; i++) {
				let file = this.files[i];
				formData.append("files[" + i + "]", file);
			}

			// add the type of file form prop
			formData.append("AssetType", this.type);
			formData.append("Folder", this.folder);

			// probably need to delete the original file.
			let guid = this.assetLink.guid;

			if (guid !== undefined) {
				FileService.delete(this.folder, guid).then(() => {
					this.uploadToApi(formData);
				});
			} else {
				this.uploadToApi(formData);
			}
		},

		uploadToApi(_formData) {
			// Make the request to the POST /multiple-files handler in api service
			FileService.upload(this.relate, _formData)
				.then((res) => {
					res.data.forEach((asset, i) => {
						switch (this.type) {
							case "1": // if it's an image we can stream it and encode in base64 to show thumbNail
								this.streamToBase64(asset);
								break;
						}
					});
					this.$refs.confirm.open(
						"Success",
						"File(s) uploaded",
						true
					);
				})
				.catch((error) => {
					this.handleError(error);
				})
				.then(() => {
					this.$refs.files.value = "";
				});
		},

		uploadFile() {
			this.files = this.$refs.files.files;
			this.submitFile();
		},

		// Modal stuff
		deleteFile(index) {
			this.$refs.confirm
				.open("Delete", "Are you sure you want to delete this file?")
				.then((confirm) => {
					if (confirm) {
						let vm = this;

						let guid = this.assetLink.guid;

						FileService.delete(this.folder, guid)
							.then(() => {
								vm.$delete(vm.assetLink, index);
							})
							.catch((error) => {
								this.handleError(error);
							});
					}
				});
		},

		handleError(err) {
			let modal_options = {
				text: "light",
				background: "danger",
			};

			let message;

			if (err.response.data != '') {

				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;

			} else {

				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
			
		},
	},

	watch: {
		// Watch for the assets prop to be populated from ajax
		asset: function () {
			this.fetchExistingAsset();
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/image-asset.vue